import useProductVariant from '@/api/inventory-management/products/useProductVariant';
import {
  CheckCircleIcon,
  XCircleIcon,
  SpinnerIcon,
} from '@phosphor-icons/react';
import { T, useGT } from 'gt-react';

export function SelectedVariantSummary({ variantId }: { variantId: string }) {
  const gt = useGT();
  const { data, isLoading, error } = useProductVariant(variantId);
  const productVariant = data?.productVariant;

  if (isLoading) {
    return (
      <div className="mt-4 p-4 border border-teal-200 rounded-md bg-teal-50 flex gap-1 items-center">
        <SpinnerIcon className="animate-spin" />
        <span className="text-sm text-teal-600">
          <T context="loading message while variant information is being fetched">
            Loading variant information...
          </T>
        </span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mt-4 p-4 border border-destructive rounded-md bg-destructive/10 flex items-center">
        <XCircleIcon className="text-destructive" />
        <span className="text-sm text-destructive">
          {error.message ||
            gt('Error loading variant', {
              context:
                'fallback error message when the selected variant summary fails to load',
            })}
        </span>
      </div>
    );
  }

  if (!productVariant) {
    return null;
  }

  return (
    <div className="mt-4 p-4 border border-teal-300/30 rounded-md bg-teal-50/50">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <CheckCircleIcon className="text-teal-600" />
          <div>
            <p className="text-sm font-medium">
              {(productVariant.originMetadata?.NAMEINVC as string) ||
                productVariant.sku ||
                gt('Selected Variant', {
                  context:
                    'fallback label for a selected product variant when no name or SKU is available',
                })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
